import './BannerComponent.css';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivismOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrongOutlined';
import { useEffect, useState, useRef } from 'react';
import Grow from '@mui/material/Grow';

function BannerComponent({currentHash}) {
    const [showMision, setShowMision] = useState(false)
    const [showVision, setShowVision] = useState(false)
    const [showValores, setShowValores] = useState(false)
    const [clear, setClear] = useState(false)
    const containerRef = useRef(null);
    
    useEffect(()=>{
        if(clear){
            setShowMision(false);
            setShowValores(false);
            setShowVision(false);
        }
    },[clear])

    // Desktop: trigger based on hash
    useEffect(()=>{
        if(currentHash === 'valores_mision_vision'){
            setTimeout(() => {
                setShowValores(true)
            }, 150);
            setTimeout(() => {
                setShowMision(true)
            }, 250);
            setTimeout(() => {
                setShowVision(true)
            }, 350);
            setClear(false)
        }else if (currentHash !== 'contacto'){
            setClear(true)
        }
        
    }, [currentHash])

    return (
        <div id="valores_mision_vision" className="App-banner_section anchor_tags" ref={containerRef}>
            <Grow in={showValores}>
            <div>
                    <VolunteerActivismIcon />
                    <h2>Valores</h2>
                    <p>Mis valores fundamentales son el compromiso, el servicio, la pasion y el profesionalismo. Siendo fiel a la palabra dada, trabajo con la promesa de acompañar en la profesionalizacion de personas y procesos; atenta a las necesidades de las organizaciones y sus lideres, con dedicación, seriedad, honradez y eficacia.</p>
            </div>
                </Grow>
                <Grow in={showMision}>
            <div>
                    <CenterFocusStrongIcon />
                    <h2>Misión</h2>
                    <p>Promover el estado de bienestar de las personas en las organizaciones. Colaborar con las pymes en el desarrollo y profesionalizacion de sus colaboradores y procesos con el mayor grado de excelencia y calidad.</p>
            </div>
                </Grow>
                <Grow in={showVision}>
            <div>
                    <VisibilityOutlinedIcon />
                    <h2>Visión</h2>
                    <p>Brindar soluciones integrales para las pequeñas y medianas empresas y sus lideres en el desarrollo de su liderazgo, cultura, clima y cambio organizacional, adaptándome a las necesidades de cada cliente.</p>
            </div>
                </Grow>
        </div>
    );
}

export default BannerComponent;